import { Link } from "react-router-dom";

export default function SignalFooter() {
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="signal-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-2.5 h-2.5 rounded-full bg-sh-blue shadow-[0_0_16px_#0a84ff]" />
              <span className="font-display font-semibold tracking-tight">Signal House</span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed max-w-xs">Gear and goods engineered for the signal, not the noise.</p>
          </div>
          <FooterCol title="Shop" links={[["All Products", "/shop/all"], ["Collections", "/shop/collections"], ["Track Order", "/shop/track"]]} />
          <FooterCol title="Company" links={[["About", "/shop/about"], ["Contact", "/shop/contact"], ["James 1:1", "/"]]} />
          <FooterCol title="Support" links={[["FAQ", "/shop#faq"], ["Shipping", "/shop/track"], ["Returns", "/shop/contact"]]} />
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Signal House. All rights reserved.</p>
          <p>Commerce by Shopify · Built by James 1:1</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{title}</p>
      <ul className="space-y-3 text-sm">
        {links.map(([label, to]) => (
          <li key={label}><Link to={to} className="text-white/70 hover:text-white transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
